import React, { useState, useEffect } from "react";
import { Spinner } from "@fluentui/react-components";
import { useMessage } from "../../blocks/message/MessageContext";
import Container from "../../blocks/Container";
import Ows from "../../utils/OwsHandler";
import { allowedContentType } from "../../utils/Helpers";

const CVProcessor = ({ document, onFinish }) => {
  const { showMessage } = useMessage();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      const documentId = await uploadDocument(document);
      if (documentId) {
        try {
          setLoading(true);
          const candidateId = await createCandidate();
          const data = await processCV(documentId, candidateId);
  
          if (data.error) {
            throw new Error(data.error.message);
          }
  
          showMessage("success", "CV processed successfully.");
        } catch (error) {
          console.error(error);
          showMessage("error", "An error occurred while processing the CV.");
        } finally {
          setLoading(false);
          onFinish();
        }
      } else {
        onFinish();
      }
    })();
  }, [document]);

  const uploadDocument = async (doc) => {
    const allowedDocType = allowedContentType(doc.contentType);

    if (!allowedDocType) {
      showMessage("error", "Invalid document type. Allowed types are PDF, DOC, DOCX");
      return;
    }

    try {
      const data = await Ows.handleRequest("Otys.Services.FileContentService.save", [doc.name, doc.content]);
      
      if (data.error) {
        throw new Error(data.error.message);
      };

      return data.response.ouid;
    } catch (error) {
      console.error(error);
    }
  };

  const createCandidate = async () => {
    try {
      const data = await Ows.handleRequest("Otys.Services.CandidateService.add", [
        {
          pointOfEntry: "manual",
          Person: {
            firstName: "New candidate",
          },
        },
      ]);

      if (data.error) {
        throw new Error(data.error.message);
      };

      return data.response;
    } catch (error) {
      console.error(error);
    }
  };

  const processCV = async (fileId, candidateId) => {
    try {
      const data = await Ows.handleRequest("Otys.Services.CandidateService.textkernelFromFile", [
        {
          fileId: fileId,
          candUid: candidateId,
        },
      ]);

      if (data.error) {
        throw new Error(data.error.message);
      };

      return data.response;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Container>
      {loading ? (
        <Spinner label="Processing CV..." labelPosition="above" />
      ) : (
        <></>
      )}
    </Container>
  );
};

export default CVProcessor;